export default {"src":"/evde-internet/_next/static/media/tel.d8ea993d.svg","height":32,"width":32};